<template>
  <div class="capital-change-detail-container">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
      <div class="nav-title">增减资详情</div>
      <div class="nav-placeholder"></div>
    </div>

    <!-- 标签页 -->
    <div class="tabs-container">
      <div v-for="tab in tabs" :key="tab.value" :class="['tab-item', { active: activeTab === tab.value }]"
        @click="activeTab = tab.value">
        {{ tab.label }}
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="list-container">
      <div v-for="item in filteredList" :key="item.id" class="section-card">
        <div class="section-title">{{ getStateText(item.state) }}</div>

        <div class="info-row">
          <span class="info-label">增减资</span>
          <span :class="['info-value', item.type > 0 ? 'negative' : 'positive']">
            {{ item.type > 0 ? '-' : '+' }}{{ item.money }} {{ inletWithdrawalCoin }}
          </span>
        </div>

        <div class="info-divider"></div>

        <!-- <div class="info-row">
          <span class="info-label">用户名</span>
          <span class="info-value">{{ item.name }}</span>
        </div> -->

        <div class="info-divider"></div>

        <div class="info-row">
          <span class="info-label">日期</span>
          <span class="info-value">{{ item.create_date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { systemInletWithdrawal } from '../api/apiList/system';
export default {
  name: 'CapitalChangeDetail',
  data() {
    return {
      activeTab: -1,
      tabs: [
        { label: '全部', value: -1 },
        { label: '处理中', value: 0 },
        { label: '已完成', value: 1 },
        { label: '已取消', value: 2 }
      ],
      inletWithdrawalCoin: '',
      inletWithdrawalData: []
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === -1) {
        return this.inletWithdrawalData;
      }
      return this.inletWithdrawalData.filter(item => item.state === this.activeTab);
    }
  },
  mounted() {
    this.getInletWithdrawal()
  },
  methods: {
    async getInletWithdrawal() {
      let info = await systemInletWithdrawal()
      this.inletWithdrawalCoin = info.coin
      this.inletWithdrawalData = info.data
    },
    getStateText(state) {
      const statusMap = {
        0: '处理中',
        1: '已完成',
        2: '已取消'
      };
      return statusMap[state] || '未知状态';
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.capital-change-detail-container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  padding-bottom: 20px;
  overflow: auto;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  position: sticky;
  top: 0;
  background-color: #000;
  z-index: 100;
}

.back-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.nav-title {
  font-size: 17px;
  font-weight: 500;
  color: #fff;
}

.nav-placeholder {
  width: 20px;
}

/* 标签页 */
.tabs-container {
  display: flex;
  justify-content: space-between;
  padding: 0 20px 20px;
  gap: 12px;
}

.tab-item {
  flex: 1;
  text-align: center;
  font-size: 15px;
  color: #999;
  padding-bottom: 8px;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #fff;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background-color: #36D8AF;
}

/* 列表容器 */
.list-container {
  padding: 0 20px;
}

/* 卡片容器 - 复用基金管理样式 */
.section-card {
  background-color: #1b1b1b;
  border-radius: 16px;
  padding: 20px 20px 0;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 10px;
}

/* 信息行 */
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

.info-label {
  font-size: 14px;
  color: #999;
}

.info-value {
  font-size: 14px;
  color: #fff;
  text-align: right;
}

.info-value.positive {
  color: #36D8AF;
}

.info-value.negative {
  color: #FF4D4F;
}

.info-divider {
  height: 1px;
  background-color: #2a2a2a;
}
</style>
